export default __webpack_public_path__ + "static/media/zoho.e5d7a0c2.svg";